"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = void 0;
exports.messages = {
    completedExaminations: {
        id: "ktx.dashboard.missing_examination",
        defaultMessage: "Elvégzett vizsgálatok"
    },
    missingExaminations: {
        id: "ktx.dashboard.missing_examinations",
        defaultMessage: "Nem elvégzett vizsgálatok"
    },
    abnormal: {
        id: "ktx.dashboard.abnormal",
        defaultMessage: "Eltérést mutat"
    },
    normal: {
        id: "ktx.dashboard.normal",
        defaultMessage: "Nincs eltérés"
    },
    cannotBePlacedOnList: {
        id: "ktx.dashboard.cannot_be_placed_on_list",
        defaultMessage: "Nem helyezhető listára"
    },
    canBePlacedOnList: {
        id: "ktx.dashboard.can_be_placed_on_list",
        defaultMessage: "Listára helyezhető"
    }
};
